import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Card, Button, LazyImage } from '@teko/ui';
import EmptyBox from '../../assets/images/empty_box.es.js';
import { ProductPrice } from '../../Common/ProductPrice/ProductPrice.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = styled(Card)`
  padding: 1rem 2rem;
  text-align: center;
`;
const Total = styled(ProductPrice)`
  min-height: unset;
  margin-left: 0.3rem;
  color: rgb(235, 33, 1);
  span {
    font-size: 1.25rem;
  }
`;
const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledButton = styled(Button)`
  margin-top: 0.875rem;
`;
const Bold = styled.span`
  font-weight: 500;
`;
const BuildPcSummary = (_a) => {
  var _b = _a, {
    total,
    selectedCount,
    onBuy,
    onAddToCart,
    addingToCart
  } = _b, props = __objRest(_b, [
    "total",
    "selectedCount",
    "onBuy",
    "onAddToCart",
    "addingToCart"
  ]);
  return /* @__PURE__ */ React.createElement(StyledCard, __spreadValues({}, props), selectedCount > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, null, t("Chi ph\xED d\u1EF1 t\xEDnh:"), /* @__PURE__ */ React.createElement(Total, {
    price: total
  })), /* @__PURE__ */ React.createElement(StyledButton, {
    loading: addingToCart,
    onClick: onBuy,
    variant: "primary",
    block: true
  }, "Mua ngay"), /* @__PURE__ */ React.createElement(StyledButton, {
    loading: addingToCart,
    onClick: onAddToCart,
    variant: "tertiary",
    block: true
  }, /* @__PURE__ */ React.createElement(Bold, null, t("Th\xEAm v\xE0o gi\u1ECF h\xE0ng")))) : /* @__PURE__ */ React.createElement(LazyImage, {
    height: 200,
    contain: true,
    src: EmptyBox
  }));
};

export { BuildPcSummary };
